module.exports = __webpack_public_path__ + "img/play.678f63c3.svg";